import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        showform: true,
        count: 1,
        menu: [
            {
                path: '/',
                name: 'Packet Zaragoza',
                icon: 'mdi-package-variant-closed',
                color: 'grey',
                counter: 0,
            },
            {
                path: '/consumibles',
                name: 'Consumibles',
                icon: 'mdi-circle-double',
                color: '#df7606',
                counter: 0,
                children: [
                    {
                        title: "FILMS",
                        path: "/consumibles/films-estirables",
                        name: "Films estirables",
                        counter: 0,
                    },
                    {
                        path: "/consumibles/films-preestirats",
                        name: "Films preestirats",
                        counter: 0,
                    },
                    {
                        path: "/consumibles/lamina-polietile-PE",
                        name: "Làmina polietilè PE",
                        counter: 0,
                    }
                ],
                children2: [    
                    {
                        title: "PRECINTES",
                        path: "/consumibles/cintes-adhesives",
                        name: "Cintes adhesives",
                        counter: 0,
                    },
                    {
                        path: "/consumibles/cintes-adhesives-impreses",
                        name: "Cintes adhesives impreses",
                        counter: 0,
                    },
                    {
                        path: "/consumibles/cintes-creppe",
                        name: "Cintes Creppe",
                        counter: 0,
                    },
                    {
                        path: "/consumibles/cintes-tramades",
                        name: "Cintes tramades",
                        counter: 0,
                    },
                    {
                        path: "/consumibles/precintes-seguretat",
                        name: "Precintes de seguretat",
                        counter: 0,
                    },
                ],
                children3: [
                    {
                        title: "CONSUMIBLES",
                        path: "/consumibles/bosses-aire",
                        name: "Bosses d'aire",
                        counter: 0,
                    },
                    {
                        path: "/consumibles/cartro-ondulat",
                        name: "Cartró ondulat",
                        counter: 0,
                    },
                    {
                        path: "/consumibles/plastic-bombolla",
                        name: "Plàstic bombolla",
                        counter: 0,
                    },
                    {
                        path: "/consumibles/bobines-foam",
                        name: "Bobines FOAM",
                        counter: 0,
                    },
                    {
                        path: "/consumibles/cantoneres-foam",
                        name: "Cantoneres FOAM",
                        counter: 0,
                    },
                    /*   {
                       path: "/consumibles/sobres-packing-list",
                        name: "Sobres Packing list",
                        counter: 0,
                    }, */
                    {
                        path: "/consumibles/flexes",
                        name: "Flexes",
                        counter: 0,
                    },
                    {
                        path: "/consumibles/bosses-mini-grip",
                        name: "Bosses mini-grip",
                        counter: 0,
                    },
                    {
                        path: "/consumibles/sobres-paper-bombolla",
                        name: "Sobres paper bombolla",
                        counter: 0,
                    },
                    {
                        path: "/consumibles/etiquetes-adhesives",
                        name: "Etiquetes adhesives",
                        counter: 0,
                    },
                    {
                        path: "/consumibles/bosses-mercat",
                        name: "Bosses mercat",
                        counter: 0,
                    },
                    {
                        path: "/consumibles/cantoneres-cartro",
                        name: "Cantoneres cartró",
                        counter: 0,
                    },
                    {
                        path: "/consumibles/paper-kraft",
                        name: "Paper KRAFT",
                        counter: 0,
                    },
                    {          
                        path: "/consumibles/farciment-porex",
                        name: "Farciment porex",
                        counter: 0,
                        text: "Chips d’embalatge en diferents formats. Ideal per farcir. També disposem de chips eco biodegradables."
                    },                          
                ],
                
            },
            {
                path: '/maquinaria',
                name: 'Maquinaria',
                icon: 'mdi-seat',
                color: '#059d8a',
                counter: 0,
                children: [
                    {      
                        name: "Enfardadores",
                        path: "/maquinaria/enfardadores",
                        counter: 0,
                    },
                    { 
                        name: "Precintadores i Grapadores",
                        path: "/maquinaria/precintadores-grapadores",
                        counter: 0,
                    },
                    { 
                        name: "Flexadores manuals i automàtiques",
                        path: "/maquinaria/flexadores",
                        counter: 0,
                    },
                    { 
                        name: "Formadores de caixes",
                        path: "/maquinaria/formadores-caixes",
                        counter: 0,
                    },
                    { 
                        name: "Manipuladores de caixes",
                        path: "/maquinaria/manipuladores-caixes",
                        counter: 0,
                    },
                    { 
                        name: "Porta fleixos",
                        path: "/maquinaria/porta-fleixos",
                        counter: 0,
                    }
                ]
            },
            {
                path: '/eco-productos',
                name: 'Eco-productos',
                icon: 'mdi-leaf',
                color: '#8ff46d',
                counter: 0,
                children: [
                    {
                        name: "Sobres packing list paper",
                        path: "/eco-productes/sobres-packing-list-paper",
                        counter: 0,
                    },
                    { 
                        name: "Nano films",
                        path: "/eco-productes/nano-films",
                        counter: 0,
                    },
                    { 
                        name: "Cantoneres FOAM reciclades",
                        path: "/eco-productes/contaneres-foam-reciclades",
                        counter: 0,
                    },
                    { 
                        name: "Cintes Kraft",
                        path: "/eco-productes/cintes-kraft",
                        counter: 0,
                    },
                    { 
                        name: "Palespan biodegradable",
                        path: "/eco-productes/palespan-biodegradable",
                        counter: 0,
                    }
                ]
            },
            {
                path: '/contacto',
                name: 'Contacto',
                icon: 'mdi-email',
                color: '#EA5F08 ',
                counter: 0,
            },
        ],
        counters: [],
    },
    mutations: {
        increment: state => state.count++,
        decrement: state => state.count--,
        handleform (state) {
            state.showform = !state.showform
        },
        counters: state => state.counters++
    },
    actions: {   
        getValue (value) {
            value.commit('handlevalue')
        }
    },
    getters: {
        navmenu: state => {
            return state.navmenu
        },

    }
})

